import React, { useContext, useLayoutEffect, useState } from 'react';

import { close } from '@/assets/icons';
import { AsaphAvatar } from '@/components/shared/Avatar';
import { Emoji } from '@/components/shared/Emoji';
import { UserAvatar } from '@/components/UserAvatar';
import { unknownDisplayName } from '@/config/constants';
import { Reaction } from '@/graphql';
import { classNames } from '@/helpers/classNames';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { useTeam } from '@/providers/TeamProvider';
import {
	Button,
	List,
	ListItem,
	ListItemText,
	SvgIcon,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useCopyToClipboard } from 'react-use';

import {
	ChatContainerContext,
	ChatContainerMessage,
} from '../../ChatContainer';
import styles from './ReactionsSheet.module.scss';

type LimitedReaction = Pick<
	Reaction,
	'createdAt' | 'emojiCode' | 'id' | 'userId'
>;

export interface ReactionsSheetProps {
	reactions: LimitedReaction[];
}

export const ReactionsSheet = ({ reactions }: ReactionsSheetProps) => {
	const {
		team: { members },
	} = useTeam();
	const [isActive, setIsActive] = useState(false);
	const [isClosing, setIsClosing] = useState(false);
	const { closeReactionsSheet } = useContext(ChatContainerContext);
	const { enqueueSnackbar } = useSnackbar();
	const fireCopyMessageEvent = useAnalyticsEvent('Chat_Copy_Message');

	useLayoutEffect(() => {
		setIsActive(true);
	}, []);

	const handleClose = () => {
		setIsClosing(true);
		setTimeout(closeReactionsSheet, 200);
	};

	return (
		<div
			className={classNames([
				styles['reactions-sheet'],
				isActive && !isClosing && styles['active'],
			])}
		>
			<div className={styles['overlay']} onClick={handleClose} />
			<div className={styles['content']}>
				<div className={styles['title']}>Reactions</div>
				<div className={styles['close']} onClick={handleClose}>
					<SvgIcon component={close} />
				</div>
				<div className={styles['list']}>
					<List>
						{reactions.map((r) => (
							<ListItem
								disableGutters
								className={styles['reaction']}
							>
								<UserAvatar userId={r.userId} size="small" />
								<ListItemText className={styles['name']}>
									{members.find((m) => m.user.id === r.userId)
										?.user.displayName ||
										unknownDisplayName}
								</ListItemText>
								<div className={styles['emoji']}>
									<Emoji code={r.emojiCode} />
								</div>
							</ListItem>
						))}
					</List>
				</div>
			</div>
		</div>
	);
};
